import Renderer from './renderer.mjs';
import { get_colorbrewer_scheme } from '../constants/colors.mjs';
import { numberFormatNoDigit } from '../helpers/numbers.mjs';

export default class ClassBreakRenderer extends Renderer {
  constructor(data, options = {}) {
    super(data, options);
    this.type = 'class_break';
    this.color_scheme = options?.color_scheme ?? 'PuRd';
    this.nb_breaks_ = data?.nb_breaks ?? 6;
    this.default_breaks = this.nb_breaks_;
    this.field = options.field;
    this.breaks_ = null;
    this.colors_ = [];
  }

  setProperties({ field, color_scheme, nb_breaks = 5 }) {
    this.field = field;
    this.color_scheme = color_scheme;
    this.nb_breaks_ = nb_breaks;
    this.breaks_ = null;
    this.colors_ = [];
  }

  refresh(geojson) {
    const values = geojson.features.map((f) => f.properties[this.field]);
    this.nb_breaks_ = Math.min(values.length, this.nb_breaks_, this.default_breaks);
    const ckmeans_breaks = ss.ckmeans(values, this.nb_breaks_);
    this.breaks_ = ckmeans_breaks.map((ckb) => {
      let population = ckb.length;
      let a_break = {
        min: ckb[0],
        max: ckb[population - 1],
        population,
      };
      a_break.label = `[${numberFormatNoDigit(a_break.min)} - ${numberFormatNoDigit(a_break.max)}]`;
      return a_break;
    });
    let i = 0;
    while (!this.colors_ || this.colors_.length === 0) {
      this.colors_ = get_colorbrewer_scheme(this.color_scheme, this.nb_breaks_ + i);
      i++;
    }
    this.colors_ = this.colors_.slice(0, this.nb_breaks_);
  }

  getPaintProperties() {
    //const colors = get_colorbrewer_scheme(this.color_scheme, this.nb_breaks_);
    const colors = this.colors_;
    let paint_props = {
      'fill-color': {
        property: this.field,
        stops: this.breaks_.map((b, i) => {
          return [b.max, colors[i]];
        }),
      },
      'fill-outline-color': colors[Math.floor(this.breaks_.length / 2)] /*'#A0A0A0',*/,
      'fill-opacity': 1,
    };
    return paint_props;
  }

  getLegendElement() {
    //const colors = get_colorbrewer_scheme(this.color_scheme, this.nb_breaks_);
    const colors = this.colors_;
    return `${this.breaks_
      .map((b, i) => {
        return `
      <div>
        <span class="legend-break" style="background-color: ${colors[i]};"></span><span>${b.label}</span>
      </div>`;
      })
      .join('')}`;
  }
}
